import React, { useState, useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import {Helmet as ReactHelmet} from 'react-helmet'
import {
    GLOBAL_CLASS_NAME,
} from '../../constants'
import {
    StyledApp,
} from "./styled";
import { AppContext } from '../../contexts'

const Navigation  = lazy(() => import('../navigation/Navigation'))
const Content  = lazy(() => import('../content/Content'))
const Footer  = lazy(() => import('../footer/Footer'))
const CookieNotification  = lazy(() => import('../cookie-notification/CookieNotification'))


const Helmet = () => {
  return (
      <ReactHelmet>
        {/* Setting the language of your page does not get more difficult than this! */}
        <html lang="en" />

        {/* Add the customCssClass from our pageMeta prop to the document body */}

        <body className={GLOBAL_CLASS_NAME}/>
        <title>Omniquad Ltd.</title>
      </ReactHelmet>
  )
}

const defaultAppData = {
    trialRequested: false,
    geolocation: null
}

const App = () => {
    const [appData, setAppData] = useState(defaultAppData);
    const [showFooter, setShowFooter] = useState(false);
    const [showContent, setShowContent] = useState(false);

    const updateAppContext = (property, value) => {

        if (property === undefined || ! property in appData) {
            return false
        }

        let newAppData = {...appData}

        newAppData[property] = value
        setAppData(newAppData)

        return true
    }


    useEffect(() => {
       setTimeout(() => {
           setShowContent(true)
       }, 10)

        setTimeout(() => {
            setShowFooter(true)
        }, 200)
    }, [showFooter, showContent])

    document.getElementById("app-preloader").style.display = "none"
    document.getElementById("root").style.visibility = "inherit"

    const renderFooter = () => {
        if (showFooter) {
            return (
                <Suspense fallback={<div id="app-preloader"><div></div></div>}>
                    <Footer/>
                </Suspense>
            )
        }

        return null
    }


    const renderContent = () => {
        if (showContent) {
            return (
                <Suspense fallback={<div id="app-preloader"><div></div></div>}>
                    <Content />
                </Suspense>
            )
        }

        return null
    }

    return (
        <AppContext.Provider value={{appData: appData, updateAppContext: updateAppContext}}>
            <StyledApp className={'App'}>
                <Helmet />
                <Router>
                    <Suspense fallback={<div id="app-preloader"><div></div></div>}>
                        <CookieNotification/>
                    </Suspense>
                    <Suspense fallback={<div id="app-preloader"><div></div></div>}>
                        <Navigation/>
                    </Suspense>
                    {renderContent()}
                    {renderFooter()}
                </Router>
            </StyledApp>
        </AppContext.Provider>
    );
}

export default App;
